import format from 'date-fns/format';
import isValid from 'date-fns/isValid';
import parseISO from 'date-fns/parseISO';

/**
 * Formats a UTC ISO string or Date to a human-readable date in the viewer's
 * local timezone.
 *
 * @example "March 20, 2025"
 */
export const formatDateToReadableLocal = (date: string | Date): string => {
  if (!date) return '';
  const d = typeof date === 'string' ? parseISO(date) : date;
  if (!isValid(d)) return '';
  return format(d, 'MMMM d, yyyy');
};
